
import { length, singleton as singleton_1, tryFind, head, tail, isEmpty, exists, choose, ofArray, filter, contains, forAll } from "../../fable_modules/fable-library-js.5.0.0-rc.2/List.js";
import { createObj, equals, stringHash } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Util.js";
import { Record, Union } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Types.js";
import { record_type, option_type, bool_type, lambda_type, unit_type, class_type, list_type, union_type, string_type } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Reflection.js";
import { ScanMatch_$reflection } from "../../Shared/Scan.js";
import { ToolDetailDto_$reflection } from "../../Shared/Tool.js";
import { DataTransfer_AssignedTool_$reflection } from "../../Shared/Set.js";
import { ToolId, FormState__startLoading, FormState_get_empty, FormState_$reflection } from "../../Shared/Shared.js";
import { Cmd_ofEffect, Cmd_none } from "../../fable_modules/Fable.Elmish.5.0.2/cmd.fs.js";
import { getScanResult } from "../../Requests/Scan.js";
import { Cmd_errorToast } from "../../Components/Toast.js";
import { concat, isNullOrWhiteSpace, join } from "../../fable_modules/fable-library-js.5.0.0-rc.2/String.js";
import { Cmd_getToolDetailDto } from "../../Requests/Tool.js";
import { parse } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Guid.js";
import { unwrap, map } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Option.js";
import { createElement } from "react";
import React from "react";
import { useTranslation } from "react-i18next";
import { Dialog } from "../../Components/Dialog.js";
import { reactApi, reactElement } from "../../fable_modules/Feliz.2.9.0/Interop.fs.js";
import { map as map_1, empty, singleton, append, delay, toList } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Seq.js";
import { SubmitInput } from "../../Components/Input.js";
import { TextButton } from "../../Components/Button.js";
import { React_useElmish_Z6C327F2E } from "../../fable_modules/Feliz.UseElmish.2.5.0/UseElmish.fs.js";
import { ProgramModule_mkProgram } from "../../fable_modules/Fable.Elmish.5.0.2/program.fs.js";
import { TextValue } from "../../Components/Text.js";
import Qr_Code from "../../../public/assets/icons/Qr_Code.svg";
import Magnifying_Glass from "../../../public/assets/icons/Magnifying_Glass.svg";
import { ScanQRCodesDialog } from "../../Widgets/Dialogs/QRCodeDialog.js";
import { Checkbox } from "../../Components/Checkbox.js";

export function isRequired(configuration) {
    return configuration.InventoryConfiguration.CompletenessCheckOnSetReturnRequired;
}

export function isComplete(configuration, set$, confirmedToolIds) {
    if (!isRequired(configuration)) {
        return true;
    }
    else {
        return forAll((tool) => contains(tool.ToolId, confirmedToolIds, {
            Equals: (x, y) => (x === y),
            GetHashCode: (x) => (stringHash(x) | 0),
        }), set$.AssignedTools);
    }
}

class InputFeedback extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["NotInSet", "Confirmed"];
    }
}

function InputFeedback_$reflection() {
    return union_type("Sets.Dialog.CompletenessCheck.InputFeedback", [], InputFeedback, () => [[], [["Item", string_type]]]);
}

class Msg extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["SetScanInput", "SubmitScan", "CodeScanned", "ScanResultFetched", "ToolDetailFetched", "FetchError", "OpenScanDialog", "CloseScanDialog", "OpenInputDialog", "CloseInputDialog", "CloseDialogs"];
    }
}

function Msg_$reflection() {
    return union_type("Sets.Dialog.CompletenessCheck.Msg", [], Msg, () => [[["Item", string_type]], [["Item", string_type]], [["Item", string_type]], [["Item1", string_type], ["Item2", list_type(ScanMatch_$reflection())]], [["Item1", string_type], ["Item2", ToolDetailDto_$reflection()]], [["Item", class_type("System.Exception")]], [], [], [], [], []]);
}

class State extends Record {
    constructor(Tools, OnToolConfirmed, ScanInput, IsScanDialogOpen, IsInputDialogOpen, InputFeedback, LastScannedCode, FormState) {
        super();
        this.Tools = Tools;
        this.OnToolConfirmed = OnToolConfirmed;
        this.ScanInput = ScanInput;
        this.IsScanDialogOpen = IsScanDialogOpen;
        this.IsInputDialogOpen = IsInputDialogOpen;
        this.InputFeedback = InputFeedback;
        this.LastScannedCode = LastScannedCode;
        this.FormState = FormState;
    }
}

function State_$reflection() {
    return record_type("Sets.Dialog.CompletenessCheck.State", [], State, () => [["Tools", list_type(DataTransfer_AssignedTool_$reflection())], ["OnToolConfirmed", lambda_type(string_type, unit_type)], ["ScanInput", string_type], ["IsScanDialogOpen", bool_type], ["IsInputDialogOpen", bool_type], ["InputFeedback", option_type(InputFeedback_$reflection())], ["LastScannedCode", option_type(string_type)], ["FormState", FormState_$reflection()]]);
}

function init(tools, onToolConfirmed) {
    return [new State(tools, onToolConfirmed, "", false, false, undefined, undefined, FormState_get_empty()), Cmd_none()];
}

function lookupCode(code, state) {
    return [new State(state.Tools, state.OnToolConfirmed, state.ScanInput, state.IsScanDialogOpen, state.IsInputDialogOpen, state.InputFeedback, code, FormState__startLoading(state.FormState)), getScanResult(code, (matches) => (new Msg(3, [code, matches])), (Item) => (new Msg(5, [Item])))];
}

function rejectCode(state) {
    const nextState = new State(state.Tools, state.OnToolConfirmed, "", state.IsScanDialogOpen, state.IsInputDialogOpen, state.InputFeedback, state.LastScannedCode, FormState_get_empty());
    if (state.IsInputDialogOpen) {
        return [new State(nextState.Tools, nextState.OnToolConfirmed, nextState.ScanInput, nextState.IsScanDialogOpen, nextState.IsInputDialogOpen, new InputFeedback(0, []), nextState.LastScannedCode, nextState.FormState), Cmd_none()];
    }
    else {
        return [nextState, Cmd_errorToast("set.return_dialog.scan_not_in_set")];
    }
}

function toolLabel(tool) {
    return join(" · ", filter((value) => !isNullOrWhiteSpace(value), ofArray([tool.DisplayName, tool.InventoryNumber, tool.SerialNumber])));
}

function update(msg, state) {
    switch (msg.tag) {
        case 6:
            return [new State(state.Tools, state.OnToolConfirmed, state.ScanInput, true, state.IsInputDialogOpen, state.InputFeedback, undefined, state.FormState), Cmd_none()];
        case 7:
            return [new State(state.Tools, state.OnToolConfirmed, state.ScanInput, false, state.IsInputDialogOpen, state.InputFeedback, undefined, state.FormState), Cmd_none()];
        case 8:
            return [new State(state.Tools, state.OnToolConfirmed, "", state.IsScanDialogOpen, true, undefined, state.LastScannedCode, state.FormState), Cmd_none()];
        case 9:
            return [new State(state.Tools, state.OnToolConfirmed, "", state.IsScanDialogOpen, false, undefined, state.LastScannedCode, state.FormState), Cmd_none()];
        case 10:
            return [new State(state.Tools, state.OnToolConfirmed, "", false, false, undefined, undefined, state.FormState), Cmd_none()];
        case 1: {
            const code = msg.fields[0];
            if (isNullOrWhiteSpace(code) ? true : state.FormState.IsLoading) {
                return [state, Cmd_none()];
            }
            else {
                return lookupCode(code.trim(), state);
            }
        }
        case 2: {
            const code_1 = msg.fields[0];
            if ((isNullOrWhiteSpace(code_1) ? true : state.FormState.IsLoading) ? true : equals(state.LastScannedCode, code_1)) {
                return [state, Cmd_none()];
            }
            else {
                return lookupCode(code_1, state);
            }
        }
        case 3: {
            const candidateToolIds = choose((scanMatch) => {
                let matchResult;
                if (scanMatch.Type === "tool") {
                    if (exists((tool) => (tool.ToolId === scanMatch.Id), state.Tools)) {
                        matchResult = 0;
                    }
                    else {
                        matchResult = 1;
                    }
                }
                else {
                    matchResult = 1;
                }
                switch (matchResult) {
                    case 0:
                        return scanMatch.Id;
                    default:
                        return undefined;
                }
            }, msg.fields[1]);
            let matchResult_1, toolId;
            if (!isEmpty(candidateToolIds)) {
                if (isEmpty(tail(candidateToolIds))) {
                    matchResult_1 = 0;
                    toolId = head(candidateToolIds);
                }
                else {
                    matchResult_1 = 1;
                }
            }
            else {
                matchResult_1 = 1;
            }
            switch (matchResult_1) {
                case 0:
                    return [state, Cmd_getToolDetailDto((tool_1) => (new Msg(4, [msg.fields[0], tool_1])), (Item) => (new Msg(5, [Item])), new ToolId(parse(toolId)))];
                default:
                    return rejectCode(state);
            }
        }
        case 4: {
            const tool_2 = msg.fields[1];
            if (exists((identifier) => {
                if (identifier.Kind === "qrCode") {
                    return identifier.Value === msg.fields[0];
                }
                else {
                    return false;
                }
            }, tool_2.AssetIdentifiers)) {
                return [new State(state.Tools, state.OnToolConfirmed, "", state.IsScanDialogOpen, state.IsInputDialogOpen, map((arg) => (new InputFeedback(1, [toolLabel(arg)])), tryFind((assignedTool) => (assignedTool.ToolId === tool_2.Id), state.Tools)), state.LastScannedCode, FormState_get_empty()), Cmd_ofEffect((_arg) => {
                    state.OnToolConfirmed(tool_2.Id);
                })];
            }
            else {
                return rejectCode(state);
            }
        }
        case 5:
            return [new State(state.Tools, state.OnToolConfirmed, state.ScanInput, state.IsScanDialogOpen, state.IsInputDialogOpen, state.InputFeedback, undefined, FormState_get_empty()), Cmd_errorToast("general.a_error_occured")];
        default:
            return [new State(state.Tools, state.OnToolConfirmed, msg.fields[0], state.IsScanDialogOpen, state.IsInputDialogOpen, state.InputFeedback, state.LastScannedCode, state.FormState), Cmd_none()];
    }
}

function EnterCodeDialog(props) {
    let Title, elems;
    const patternInput = useTranslation();
    const t = patternInput[0];
    return createElement(Dialog, (Title = t("set.return_dialog.enter_code"), {
        Body: singleton_1(reactElement("div", createObj(ofArray([["className", join(" ", ["grid", "gap-3"])], (elems = toList(delay(() => append(singleton(reactElement("p", {
            className: join(" ", ["text-sm"]),
            children: t("set.return_dialog.enter_code_hint"),
        })), delay(() => {
            let matchValue;
            return append(singleton(createElement(SubmitInput, {
                AutoFocus: true,
                ComponentState: props.ComponentState,
                Label: t("general.qr_code"),
                OnChange: props.OnChange,
                OnSubmit: props.OnSubmit,
                TestId: "return-set-scan-input",
                ValidationMessage: unwrap((matchValue = props.Feedback, (matchValue != null) ? ((matchValue.tag === 0) ? t("set.return_dialog.scan_not_in_set") : undefined) : undefined)),
                Value: props.Value,
            })), delay(() => {
                let arg_1;
                const matchValue_1 = props.Feedback;
                let matchResult, toolName;
                if (matchValue_1 != null) {
                    if (matchValue_1.tag === 1) {
                        matchResult = 0;
                        toolName = matchValue_1.fields[0];
                    }
                    else {
                        matchResult = 1;
                    }
                }
                else {
                    matchResult = 1;
                }
                switch (matchResult) {
                    case 0:
                        return singleton(reactElement("p", {
                            "data-test-id": "return-set-scan-input-confirmed",
                            className: join(" ", ["text-sm", "text-green-700"]),
                            children: (arg_1 = {
                                tool: toolName,
                            }, patternInput[1].t("set.return_dialog.scan_confirmed", arg_1)),
                        }));
                    default: {
                        return empty();
                    }
                }
            }));
        })))), ["children", reactApi.Children.toArray(Array.from(elems))])])))),
        Controls: ofArray([createElement(TextButton, {
            ComponentState: props.ComponentState,
            Label: t("general.close"),
            OnClick: props.OnClose,
            TestId: "return-set-scan-input-close",
            Variant: "blueButton",
        }), createElement(TextButton, {
            ComponentState: props.ComponentState,
            Label: t("set.return_dialog.confirm_code"),
            OnClick: props.OnSubmit,
            TestId: "return-set-scan-input-submit",
            Variant: "blueButton",
        })]),
        IsOpen: props.IsOpen,
        OnClose: props.OnClose,
        Title: Title,
    }));
}

export function SetReturnCompletenessCheck(props) {
    let elems_2;
    const patternInput = useTranslation();
    const t = patternInput[0];
    const scanOnly = props.Configuration.InventoryConfiguration.CompletenessCheckOnSetReturnScanOnly;
    const patternInput_1 = React_useElmish_Z6C327F2E(() => ProgramModule_mkProgram(() => init(props.Set.AssignedTools, (toolId) => {
        props.OnToolConfirmed([toolId, true]);
    }), update, (_arg_1, _arg_1_1) => {
    }), undefined, undefined);
    const state_1 = patternInput_1[0];
    const dispatch = patternInput_1[1];
    const componentState = (props.FormState.IsLoading ? true : state_1.FormState.IsLoading) ? "disabled" : "enabled";
    const confirmedCount = length(filter((tool) => contains(tool.ToolId, props.ConfirmedToolIds, {
        Equals: (x, y) => (x === y),
        GetHashCode: (x) => (stringHash(x) | 0),
    }), props.Set.AssignedTools)) | 0;
    const allConfirmed = confirmedCount === length(props.Set.AssignedTools);
    const dependencies_2 = [allConfirmed];
    reactApi.useEffect(() => {
        if (allConfirmed) {
            dispatch(new Msg(10, []));
        }
    }, dependencies_2);
    return reactElement("div", createObj(ofArray([["data-test-id", "return-set-completeness-check"], ["className", join(" ", ["grid", "gap-2"])], (elems_2 = toList(delay(() => append(singleton(createElement(TextValue, {
        FontWeight: "bold",
        TestId: "",
        Text: t("set.return_dialog.completeness_check_title"),
    })), delay(() => append(singleton(reactElement("p", {
        className: join(" ", ["text-sm"]),
        children: t(scanOnly ? "set.return_dialog.scan_only_hint" : "set.return_dialog.completeness_check_hint"),
    })), delay(() => {
        let elems, Label, Label_1;
        return append(scanOnly ? append(singleton(reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "flex-wrap", "gap-6", "py-2"])], (elems = [createElement(TextButton, (Label = t("set.return_dialog.scan_with_camera"), {
            ComponentState: componentState,
            Icon: Qr_Code(),
            Label: Label,
            OnClick: () => {
                dispatch(new Msg(6, []));
            },
            TestId: "return-set-scan-camera",
            Variant: "blueButton",
        })), createElement(TextButton, (Label_1 = t("set.return_dialog.enter_code"), {
            ComponentState: componentState,
            Icon: Magnifying_Glass(),
            Label: Label_1,
            OnClick: () => {
                dispatch(new Msg(8, []));
            },
            TestId: "return-set-scan-enter",
            Variant: "blueButton",
        }))], ["children", reactApi.Children.toArray(Array.from(elems))])])))), delay(() => append(state_1.IsScanDialogOpen ? singleton(createElement(ScanQRCodesDialog, {
            IsOpen: state_1.IsScanDialogOpen,
            OnClose: () => {
                dispatch(new Msg(7, []));
            },
            OnQRCodeRead: (code) => {
                dispatch(new Msg(2, [code]));
            },
        })) : empty(), delay(() => (state_1.IsInputDialogOpen ? singleton(createElement(EnterCodeDialog, {
            ComponentState: componentState,
            Feedback: unwrap(state_1.InputFeedback),
            IsOpen: state_1.IsInputDialogOpen,
            OnChange: (arg) => {
                dispatch(new Msg(0, [arg]));
            },
            OnClose: () => {
                dispatch(new Msg(9, []));
            },
            OnSubmit: () => {
                dispatch(new Msg(1, [state_1.ScanInput]));
            },
            Value: state_1.ScanInput,
        })) : empty()))))) : empty(), delay(() => {
            let elems_1;
            return append(singleton(reactElement("div", createObj(ofArray([["className", join(" ", ["grid", "gap-1"])], (elems_1 = toList(delay(() => map_1((tool_1) => {
                let Label_2;
                return Checkbox((Label_2 = toolLabel(tool_1), {
                    ComponentState: scanOnly ? "disabled" : componentState,
                    IsChecked: contains(tool_1.ToolId, props.ConfirmedToolIds, {
                        Equals: (x_1, y_1) => (x_1 === y_1),
                        GetHashCode: (x_1) => (stringHash(x_1) | 0),
                    }),
                    Label: Label_2,
                    OnCheck: (value_11) => {
                        props.OnToolConfirmed([tool_1.ToolId, value_11]);
                    },
                    TestId: concat("return-set-completeness-", ...tool_1.ToolId),
                }));
            }, props.Set.AssignedTools))), ["children", reactApi.Children.toArray(Array.from(elems_1))])])))), delay(() => {
                let arg_2;
                return singleton(reactElement("p", {
                    "data-test-id": "return-set-completeness-count",
                    className: join(" ", ["text-sm", "text-text-muted"]),
                    children: (arg_2 = {
                        confirmed: confirmedCount,
                        total: length(props.Set.AssignedTools),
                    }, patternInput[1].t("set.return_dialog.confirmed_count", arg_2)),
                }));
            }));
        }));
    })))))), ["children", reactApi.Children.toArray(Array.from(elems_2))])])));
}

